class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.runWhenIdle(() => {
      this.setTopbar();
      this.initialiesGaEvents();
    });
    this.initMegaMenus();
    this.searchAnimate();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false, { passive: true });

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.querySelector('.header-wrapper').offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler, { passive: true });
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    // this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }

  setTopbar(){
    const eleSliders =  this.querySelectorAll('.hd-TopBar_Items');
    if (!eleSliders.length) return;

    const initSlider = (el) => {
      if (!el || el.dataset.sliderInitialized === 'true') return;
      el.dataset.sliderInitialized = 'true';
      const hasMultipleItems = el.querySelectorAll('.hd-TopBar_Item').length > 1;

      if (hasMultipleItems) {
        this.runWhenIdle(() => {
          const flkty = new Flickity(el, {"pageDots": false, "prevNextButtons": false, "autoPlay": 4000, "fade": true,"wrapAround": true,"pauseAutoPlayOnHover": false});
          flkty.resize();
        });
      }

      const promotion = el.getAttribute('data-promotion');
      el.addEventListener('click',() => {
        setSelectPromotion(promotion,'','')
      });
      observerIns.observe(el);
    };

    if ('IntersectionObserver' in window) {
      const topbarObserver = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            initSlider(entry.target);
            obs.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px 0px' });

      eleSliders.forEach(el => topbarObserver.observe(el));
      return;
    }

    eleSliders.forEach(initSlider);
  }

  initialiesGaEvents() {
    // For desktop menu
    const mainMenu = this.querySelectorAll('.header__inline-menu .hd-list_Item');
    mainMenu.forEach(el => {
      const headerMenu = el.querySelector('header-menu');
      if (!headerMenu) {
        const nav = el.querySelector('.header__main-menu-item');
        nav.addEventListener('click', () => {
          const subName = nav.querySelector('span').innerHTML.trim();
          setHeaderPromotion('Header Navigation', subName, '');
        });
        return;
      }
  
      const megaMenu = headerMenu.querySelectorAll('.mega-menu__list .hd-NavList_Column-navigation');
      const name = headerMenu.querySelector('.header__main-menu-item span').innerText.trim();
      megaMenu.forEach(menu => {
        menu.querySelectorAll('.hd-NavList_Items').forEach(submenu => {
          const section = submenu.previousElementSibling.innerHTML.trim();
          submenu.querySelectorAll('li').forEach(item => {
            item.querySelector('a').addEventListener('click', (e) => {
              const subName = e.target.innerHTML.trim();
              setHeaderPromotion(name, section, subName);
            });
          });
        });
      });
  
      const menuImages = headerMenu.querySelectorAll('.mega-menu-images .hd-NavList_Column-navigation');
      menuImages.forEach((item, index) => {
        item.querySelector('a').addEventListener('click', () => {
          setHeaderPromotion('Top nav images', `${name} ${(index + 1)}`, '');
        });
      });
    });

    // For Mobile menu
    const menuItems = document.querySelectorAll('nav.menu-drawer__navigation > .menu-drawer__menu > li');
    menuItems.forEach(el => {
      const headerMenu = el.querySelector('details.Details-menu-drawer-menu-item');
      if (!headerMenu) {
        const nav = el.querySelector('.main-menu-drawer__menu-item');
        nav.addEventListener('click', () => {
          const subName = nav.innerHTML.trim();
          setHeaderPromotion('Header Mobile Navigation', subName, '');
        });
        return;
      }

      const megaMenu = headerMenu.querySelectorAll('.menu-drawer__inner-submenu > .menu-drawer__menu > li:not(.hd-NavList_Column-navigation)');
      megaMenu.forEach(menu => {
        const name = menu.parentNode.getAttribute('data-title')
        const headerSubMenu = menu.querySelector('details.Details-menu-drawer-submenu-item');
        if (!headerSubMenu) {
          const nav = menu.querySelector('.child-menu-drawer__menu-item');
          if(nav){
            nav.addEventListener('click', () => {
              const subName = nav.innerHTML.trim();
              setHeaderPromotion(name, subName, '');
            });
          }
          return;
        }

        const megaSubMenu = headerSubMenu.querySelectorAll('.menu-drawer__menu li:not(.hd-NavList_Column-navigation)');
        megaSubMenu.forEach(submenu => {
          const section = submenu.parentNode.getAttribute('data-title')
            submenu.querySelector('a').addEventListener('click', (e) => {
              const subName = e.target.innerHTML.trim();
              setHeaderPromotion(name, section, subName);
            });
        });
        
        const megaSubMenuImages = headerSubMenu.querySelectorAll('.menu-drawer__menu li.hd-NavList_Column-navigation');
        megaSubMenuImages.forEach((menuImage,index) => {
          const subname = menuImage.parentNode.getAttribute('data-title')
          menuImage.querySelector('a').addEventListener('click', (e) => {
            setHeaderPromotion('Top nav images', name, `${subname} ${(index + 1)}`);
          });
        });
      });

      const megaMenuImages = headerMenu.querySelectorAll('.menu-drawer__inner-submenu > .menu-drawer__menu > li.hd-NavList_Column-navigation');
      megaMenuImages.forEach((menuImage,index) => {
        const name = menuImage.parentNode.getAttribute('data-title')
        menuImage.querySelector('a').addEventListener('click', (e) => {
          setHeaderPromotion('Top nav images', `${name} ${(index + 1)}`, '');
        });
      });
    });
  }

  searchAnimate(){
    const items = this.querySelectorAll('.animate');
    if(items){
      let currentIndex = 0;
      const showNextItem = () => {
        items.forEach((item) => {
          item.style.display = 'none';
          item.classList.remove('slide-up');
        });
        items[currentIndex].style.display = 'inline';
        setTimeout(() => {
          items[currentIndex].classList.add('slide-up');
          currentIndex = (currentIndex + 1) % items.length;
        }, 10); 
      }

      showNextItem();
      // Change item every 2 seconds
      setInterval(showNextItem, 2000);
    }

  }

  initMegaMenus(){
    const mainContainer = document.querySelectorAll('.flex-new-menu');
    mainContainer && mainContainer.forEach(e => {
      const imgContainer = e.querySelector('.mega-menu-images li');
      const menuContainer = e.querySelector('.mega-menu-items');
      if(imgContainer && imgContainer.textContent.trim() === ''){
        imgContainer.parentElement.style.display = "none";
        menuContainer && menuContainer.classList.add('full-w');
      }
    })
  }

  runWhenIdle(callback) {
    if (typeof callback !== 'function') return;
    if ('requestIdleCallback' in window) {
      requestIdleCallback(callback, { timeout: 500 });
    } else {
      setTimeout(callback, 0);
    }
  }
}

customElements.define('sticky-header', StickyHeader);